jest.mock("@/config/brands", () => ({
  default: jest.fn(),
  __esModule: true
}));

import Vuex from "vuex";
import storePublisherPlugin from "@/store/plugins";
import state from "@/store/state";
import mutations from "@/store/mutations";
import actions from "@/store/actions";
import getters from "@/store/getters";

describe("Vuex Store", () => {
  let store;

  beforeEach(() => {
    store = new Vuex.Store({
      plugins: [storePublisherPlugin],
      state,
      mutations,
      actions,
      getters
    });
  });

  it("state has correct default values", () => {
    expect(store.state).toEqual(state);
  });

  it("mutations change state correctly", () => {
    store.commit("ON_ROUTE", "payload");
    expect(store.state.route).toBe("payload");
  });

  it("actions commit mutations correctly", () => {
    store.dispatch("DO_ROUTE", "payload");
    expect(store.state.route).toBe("payload");
  });
});
